import { render, staticRenderFns } from "./OrderFilter.vue?vue&type=template&id=1f51074f&scoped=true&"
import script from "./OrderFilter.vue?vue&type=script&lang=js&"
export * from "./OrderFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilter.vue?vue&type=style&index=0&id=1f51074f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51074f",
  null
  
)

export default component.exports